import { useCart } from '@/api/carts/carts.hooks';
import { theme } from '@/config/theme';
import { formatMoneyString } from '@/utils/format-money-string';
import { ShoppingCart } from '@mui/icons-material';
import { Badge, Box, IconButton, Tooltip, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClearCartButton } from '@components/clear-cart-button.component';
import { useTranslation } from 'react-i18next';

export const ItemsGridFooter = memo(function ItemsGridFooter() {
  const navigate = useNavigate();
  const { t } = useTranslation(['customer', 'common']);
  const { data } = useCart({ staleTime: 5 * 60 * 1000 });
  const cartItems = useMemo(() => data?.cartItems || [], [data]);
  const cartCount = useMemo(() => cartItems.length || 0, [cartItems]);
  const totalAmount = useMemo(
    () => data?.priceCalculation?.totalAmount || 0,
    [data],
  );

  const itemsText =
    cartCount === 1 ? t('customer:items.footer.itemsSingular') : t('customer:items.footer.itemsPlural');

  return (
    <Box
      sx={{
        p: 0.5,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        borderTop: 1,
        borderColor: 'divider',
        gap: 2,
      }}
    >
      <ClearCartButton />
      <Typography variant="body2" color="text.secondary">
        {cartCount} {itemsText} | {formatMoneyString(totalAmount)}
      </Typography>
      <Tooltip title={t('common:tooltips.openCart')}>
        <IconButton
          size="small"
          onClick={() => navigate('/bp/c/cart')}
          sx={{ color: theme.palette.text.primary, mr: 1, p: 1 }}
        >
          <Badge badgeContent={cartCount} color="error">
            <ShoppingCart sx={{ fontSize: 20 }} />
          </Badge>
        </IconButton>
      </Tooltip>
    </Box>
  );
});
